import React from "react"

export default function VideoCard({ url }) {
  if (!url) return ""
  return (
    <div className="store-item video-shop-list__item">
      <video className="video-card" autoPlay loop muted controls={false} playsInline preload={"auto"} loading="eager" fetchPriority="high">
        <source src={url} />
      </video>
    </div>
  )
}
